import CorrespondenceAddressModelBase from '../_generated/modelBases/correspondence-address-model-base';

export default class CorrespondenceAddressModel extends CorrespondenceAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
